import React, { useState } from "react";
import "./SapAbap.css";
import DownloadForm from "../DownloadForm/DownloadForm"; // Adjust path if needed

const SapFincon = () => {
    const [showForm, setShowForm] = useState(false);
  
    const handleDownloadClick = () => {
      setShowForm(true);
    };
  
    const handleCloseForm = () => {
      setShowForm(false);
    };
  return (
    <div className="sapfincon-wrapper">
      {/* Animated Background Circles */}
      <div className="background-animation">
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
      </div>

      {/* Header Section - Unchanged */}
      <div
        className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
        style={{ marginBottom: '30px' }}
      >
        <div className="container text-center py-5" style={{ marginTop: "-30px" }}>
          <h1 className="text-white display-1">Finance and Controlling</h1>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase">
              <a className="text-white" href="">Home</a>
            </p>
            <i className="fa fa-angle-double-right pt-1 px-3"></i>
            <p className="m-0 text-uppercase">SAP</p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="sapfincon-flexbox">
        <div className="sapfincon-left">
          <div className="sapfincon-wrapper zoom-effect">

          <img
            src="/assets/img/sapfince.jpg"
            alt="SAP Banner"
            className="sapfincon-main-image"
          />
        </div>
</div>
        <div className="sapfincon-right">
          <h2 className="sapfincon-title">Master financial management and cost control.</h2>

          <p className="sapfincon-description">
            SAP FICO is the backbone of financial processing in organizations, helping businesses streamline
            accounting, financial reporting, and cost management.
          </p>

          <ul className="sapfincon-list">
            {[
              'Understand financial accounting (FI) and controlling (CO) concepts',
              'Learn how to configure General Ledger (GL), Accounts Payable (AP), and Accounts Receivable (AR)',
              'Perform asset accounting and bank reconciliation',
              'Implement cost center and profit center accounting',
              'Generate balance sheets and financial statements',
              'Learn integration with other SAP modules (MM, SD, HR)',
            ].map((text, idx) => (
              <li className="sapfincon-list-item" key={idx}>
                <span className="sapfincon-icon">
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998
                       26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997
                       26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206
                       0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"/>
                  </svg>
                </span>
                <span className="sapfincon-text">{text}</span>
              </li>
            ))}
          </ul>

          <p className="sapfincon-careers">SAP FICO Consultant, Financial Analyst, SAP Accountant</p>
        </div>
      </div>

      {/* New Content Section - SAP S/4 HANA FICO */}
      <div className="sapfincon-content-section">
        <div className="container">
          {/* Course Upgrade Section */}
          <div className="upgrade-section">
            <h2 className="section-title">
              <strong>Upgrade your coding skills with BDM Technology' Best-Selling SAP Finance and controlling Course!</strong>
            </h2>
            <p className="section-description">
              SAP FICO is the backbone of financial processing in organizations, helping businesses streamline accounting, financial reporting, and cost management.
            </p>
          </div>

          {/* Why Study Section */}
          <div className="why-study-section">
            <div style={{marginTop:"-40px",marginBottom:"-30px"}}>
            <h3 className="subsection-title">
              <strong>Why Study SAP Finance and Controlling (FICO)?</strong>
            </h3>
            <p className="subsection-description">
              SAP S/4HANA Finance (FICO) is a leading financial management solution that helps businesses streamline accounting, financial planning, and reporting. Learning FICO opens doors to high-paying careers in finance, ERP consulting, and enterprise resource planning!
            </p>
            </div>
          </div>

          {/* Benefits Section */}
          <div className="benefits-section">
            <div style={{marginTop:"-30px"}}>
            <h3 className="subsection-title">
              <strong>Benefits of Learning SAP FICO</strong>
            </h3>
            <ul className="benefits-list">
              <li><strong>High Demand Skill</strong> – Widely used in enterprises for financial management.</li>
              <li><strong>Real-Time Data Processing</strong> – Enhances financial reporting and decision-making.</li>
              <li><strong>Automation & Efficiency</strong> – Streamlines accounting, auditing, and compliance.</li>
              <li><strong>Seamless Integration</strong> – Works with other SAP modules for better business operations.</li>
              <li><strong>Career Growth</strong> – Opens doors to roles in finance, ERP consulting, and accounting.</li>
              <li><strong>Global Opportunities</strong> – Used by top companies worldwide.</li>
              <li><strong>Competitive Salaries</strong> – Strong earning potential in the ERP and finance sector.</li>
            </ul>
            </div>
          </div>

          {/* Future Scope Section */}
          <div className="future-scope-section">
            <div style={{marginTop:"-30px"}}>
            <h3 className="subsection-title">
              <strong>Future Scope of Learning SAP FICO</strong>
            </h3>
            <ul className="scope-list">
              <li><strong>Growing Industry Demand</strong> – Increasing adoption by global enterprises for financial management.</li>
              <li><strong>Cloud-Based ERP Expansion</strong> – Rising use of SAP S/4HANA on cloud platforms.</li>
              <li><strong>AI & Automation Integration</strong> – Advanced analytics and automation transforming finance operations.</li>
              <li><strong>High-Paying Career Opportunities</strong> – Strong demand for SAP FICO consultants and financial analysts.</li>
              <li><strong>Wide Industry Adoption</strong> – Used in banking, healthcare, retail, manufacturing, and more.</li>
              <li><strong>Regulatory Compliance & Reporting</strong> – Essential for businesses to meet financial regulations.</li>
              <li><strong>Continuous Innovation</strong> – Regular updates from SAP ensure future relevance.</li>
            </ul>
          </div>
          </div>

          {/* Key Features Section */}
          <div className="key-features-section">
            <div style={{marginTop:"-30px"}}>
            <h3 className="subsection-title">
              <strong>Key Features of BDM Technology</strong>
            </h3>
            <div className="features-grid">
              <div className="feature-item">
                <h4>100% Job-Oriented Training</h4>
                <p>Curriculum tailored to industry requirements, ensuring you gain the skills employers are looking for.</p>
              </div>
              <div className="feature-item">
                <h4>Industry Expert Faculties</h4>
                <p>Learn from seasoned professionals with real-world experience.</p>
              </div>
              <div className="feature-item">
                <h4>Flexible Demo Class Available</h4>
                <p>Opportunity to attend a demo session and experience the training style before enrolling.</p>
              </div>
              <div className="feature-item">
                <h4>Completed 400+ Batches</h4>
                <p>Proven track record with hundreds of successful batches, demonstrating program reliability and effectiveness.</p>
              </div>
              <div className="feature-item">
                <h4>Certification Guidance</h4>
                <p>Support throughout your journey to help you earn relevant certifications that boost your career.</p>
              </div>
              <div className="feature-item">
                <h4>Live Practical Sessions</h4>
                <p>Hands-on, interactive sessions to reinforce learning and apply concepts in real-time.</p>
              </div>
              <div className="feature-item">
                <h4>Peaceful Environment</h4>
                <p>A conducive learning atmosphere that helps you focus and maximize your learning potential.</p>
              </div>
              </div>
            </div>
          </div>

          {/* Who Should Attend Section */}
          <div className="who-attend-section">
            <div className="one">
            <h3 className="subsection-title">

              <strong>Who Should Attend</strong>
            </h3>
            <ul className="attend-list">
              <li>Aspiring SAP FICO consultants or ERP Professionals</li>
              <li>Finance, accounting, and commerce graduates aiming for a tech-finance career</li>
              <li>Chartered accountants looking to transition into ERP based finance roles</li>
            </ul>
          </div>
          </div>

          {/* Hiring Companies Section */}
         <div className="hiring-companies-section">
          <div  className="two">
  <h3 className="subsection-title">
    <strong>Hiring Companies</strong>
  </h3>
  <div className="companies-grid">
    {[
      { name: "Cognizant", logo: "/assets/img/Cognizant.png" },
      { name: "TCS", logo: "/assets/img/tcs.jpg" },
      { name: "Infosys", logo: "/assets/img/infoysis.jpg" },
      { name: "IBM", logo: "/assets/img/ibm.png" },
      { name: "HCL", logo: "/assets/img/hcl.png" },
      { name: "Accenture", logo: "/assets/img/Accenture.png" },
      { name: "Capgemini", logo: "/assets/img/capgemini.png" },
      { name: "Deloitte", logo: "/assets/img/Deloitte.png" },
      { name: "NTTDATA", logo: "/assets/img/nttdata.png" },
      { name: "Wipro", logo: "/assets/img/wipro.png" },
      { name: "KaarTech", logo: "/assets/img/KaarTech.png" },
      { name: "L&T", logo: "/assets/img/lt.png" },
      { name: "Siemens", logo: "/assets/img/Siemens.png" },
      { name: "Tech Mahindra", logo: "/assets/img/techmahindra.png" },
    ].map((company, index) => (
      <div className="company-card" key={index}>
        <img
          src={company.logo}
          alt={company.name}
          className="company-logo"
        />
        <span className="company-name">{company.name}</span>
      </div>
    ))}
  </div>
  </div>
</div>


          {/* Salary Overview Section */}
          <div className="salary-overview-section">
            <div  className="three">
            <h3 className="subsection-title">
              <strong>Salary Overview</strong>
            </h3>
            <div className="salary-grid">
              <div className="salary-item">
                <h4>Entry-Level (0-2 Years)</h4>
                <p className="salary-amount">₹5 - 8 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Mid-Level (2-5 Years)</h4>
                <p className="salary-amount">₹8 - 14 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Senior-Level (5+ Years)</h4>
                <p className="salary-amount">₹14 - 22+ LPA</p>
              </div>
              <div className="salary-item">
                <h4>Solution Architects & Finance Leads</h4>
                <p className="salary-amount">₹25 - 35 LPA</p>
                
              </div>
            </div>
             
          </div>
          <div className="download-section">
  <h3 className="download-heading">
    Want to know more? <br />
    <span>Please download the course PDF.</span>
  </h3>

  <button className="download-button" onClick={handleDownloadClick}>
    📄 Download Course PDF
  </button>
</div>
</div>

           {showForm && (
        <DownloadForm
          onClose={handleCloseForm}
          courseName="SAPm FICO"
          pdfUrl="/uploads/pdfs/01.pdf" // Replace with actual path
        />
      )}
        </div>
      </div>

     
    </div>
  );
};

export default SapFincon;